import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { getFormArrayErrorMessage } from '../../../utils/errors';
import { RHFDropdown } from '../../../components/rhf';
import { ButtonDelete } from '../../../components/Buttons';
import { order, orderNull } from '../../../utils/sort';

export const TermMemberTable = ({
    control,
    errors,
    fields,
    getValues,
    politicalEntities,
    disabled,
    onRemoveMember
}) => {
    const politicalEntityTemplate = (rowData) => {
        return (
            <div className='flex-column'>
                <RHFDropdown
                    name={`members[${rowData.index}].political_entity`}
                    key={`member-${rowData.item.member_id}-political_entity`}
                    control={control}
                    rules={{ required: 'Zvolte politický subjekt' }}
                    placeholder='Zvolte politický subjekt'
                    inputProps={{
                        options: politicalEntities,
                        optionValue: 'id',
                        optionLabel: 'abbreviation',
                        emptyMessage: 'Nejsou k dispozici žádné politické subjekty',
                        showClear: false
                    }}
                />
                {getFormArrayErrorMessage(errors, 'members', rowData.index, 'political_entity')}
            </div>
        );
    };

    const buttonsColumn = (rowData) => {
        return (
            <ButtonDelete
                type='button'
                tooltip='Odebrat člena'
                rounded
                onClick={() => onRemoveMember(rowData.item, rowData.index)}
                disabled={disabled}
            />
        );
    };

    const politicalEntitySort = (e) => {
        return e.data.toSorted((a, b) => {
            const aPoliticalEntityId = getValues(`members[${a.index}].political_entity`);
            const bPoliticalEntityId = getValues(`members[${b.index}].political_entity`);

            // one of the inputs is empty
            if (!aPoliticalEntityId || !bPoliticalEntityId) {
                return orderNull(aPoliticalEntityId, bPoliticalEntityId);
            }

            const aAbbreviation = politicalEntities.find((entity) => entity.id === aPoliticalEntityId).abbreviation;
            const bAbbreviation = politicalEntities.find((entity) => entity.id === bPoliticalEntityId).abbreviation;

            return order(aAbbreviation, bAbbreviation) * e.order;
        });
    };

    return (
        <DataTable
            value={fields.map((item, index) => ({
                item,
                index
            }))}
            removableSort
            sortField='item.last_name'
            sortOrder={1}
            breakpoint='500px'
            emptyMessage='Nebyli vybráni žádní členové'
        >
            <Column field='item.member_id' header='ID' sortable />
            <Column field='item.first_name' header='Jméno' sortable />
            <Column field='item.last_name' header='Příjmení' sortable />
            <Column
                field='__.political_entity'
                header='Politický subjekt'
                body={politicalEntityTemplate}
                sortable
                sortFunction={politicalEntitySort}
            />
            <Column body={buttonsColumn} align='right' />
        </DataTable>
    );
};
